import React, { useEffect, useState } from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
const OFFER_DURATION_SECONDS = 23 * 60 * 60 + 59 * 60 + 59;
function getTimeUnits(totalSeconds: number) {
  return {
    hours: Math.floor(totalSeconds / 3600),
    minutes: Math.floor(totalSeconds % 3600 / 60),
    seconds: totalSeconds % 60
  };
}
const includedItems = ['6 módulos prácticos', '4 bonos incluidos', 'Plan de acción de 90 días', '25 casos de éxito documentados', 'Entrenadores reales por disciplina'];
function OfferCard() {
  return <article className="premium-card relative bg-[#141210] p-7 sm:p-9" data-id="element-100">
      <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.16em] text-sage" data-id="element-101">
        Megapack Entrenadores +
      </p>
      <h3 className="mt-3 font-display text-5xl font-bold leading-none tracking-[-0.04em] text-ivory sm:text-6xl" data-id="element-102">
        Casos de éxito.
      </h3>
      <p className="mt-7 font-mono text-4xl font-semibold tracking-[-0.05em] text-gold" data-id="element-103">
        $27.990
      </p>
      <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.1em] text-sage" data-id="element-104">
        ARS · pago único · Mercado Pago
      </p>
      <ul className="my-8 grid gap-3.5 sm:grid-cols-2" data-id="element-105">
        {includedItems.map(item => <li key={item} className="flex gap-3 text-sm leading-5 text-ivory" data-id="element-106">
            <CheckIcon className="mt-0.5 shrink-0 text-gold" size={16} strokeWidth={2.5} aria-hidden="true" data-id="element-107" />
            {item}
          </li>)}
      </ul>
      <a href="https://librofy-store.myshopify.com/cart/47910701957341:1" className="gold-button flex min-h-14 items-center justify-center bg-gold px-5 text-center font-mono text-[10px] font-bold uppercase tracking-wider text-ink transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold" data-id="element-108">
        Quiero el Megapack — $27.990
      </a>
      <p className="mt-4 text-center text-xs text-sage" data-id="element-109">
        Acceso inmediato · Garantía de 7 días
      </p>
    </article>;
}
export function PricingSection() {
  const [secondsLeft, setSecondsLeft] = useState(OFFER_DURATION_SECONDS);
  useEffect(() => {
    let endsAt = Number(window.sessionStorage.getItem('megapack-pricing-ends-at'));
    if (!endsAt || endsAt <= Date.now()) {
      endsAt = Date.now() + OFFER_DURATION_SECONDS * 1000;
      window.sessionStorage.setItem('megapack-pricing-ends-at', String(endsAt));
    }
    const updateTime = () => {
      const next = Math.max(0, Math.ceil((endsAt - Date.now()) / 1000));
      if (next === 0) {
        endsAt = Date.now() + OFFER_DURATION_SECONDS * 1000;
        window.sessionStorage.setItem('megapack-pricing-ends-at', String(endsAt));
        setSecondsLeft(OFFER_DURATION_SECONDS);
        return;
      }
      setSecondsLeft(next);
    };
    updateTime();
    const intervalId = window.setInterval(updateTime, 1000);
    return () => window.clearInterval(intervalId);
  }, []);
  const time = getTimeUnits(secondsLeft);
  const timeBoxes = [[time.hours, 'Horas'], [time.minutes, 'Min'], [time.seconds, 'Seg']];
  return <section id="pricing" className="border-y border-[#d4af37]/18 bg-card px-5 py-20 sm:px-8 sm:py-28" aria-label="Oferta Megapack Entrenadores" data-id="element-110">
      <div className="mx-auto max-w-6xl" data-id="element-111">
        <Reveal data-id="element-112">
          <SectionHeading centered eyebrow="Oferta única" title="El Megapack completo, en un solo pago." description="Acceso inmediato a todos los módulos, bonos y casos documentados." data-id="element-113" />
        </Reveal>

        <Reveal className="mx-auto mt-14 max-w-[760px]" data-id="element-114">
          <OfferCard data-id="element-115" />
        </Reveal>

        <Reveal className="mx-auto mt-10 max-w-[640px]" data-id="element-116">
          <div className="border border-[#d4af37]/45 bg-[#d4af37]/[0.05] p-5 sm:flex sm:items-center sm:justify-between sm:gap-6" data-id="element-117">
            <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.14em] text-gold-dark" data-id="element-118">
              Este precio cierra en
            </p>
            <div className="mt-4 flex justify-center gap-2 sm:mt-0" role="timer" aria-live="polite" data-id="element-119">
              {timeBoxes.map(([value, label]) => <div key={String(label)} className="text-center" data-id="element-120">
                  <div className="min-w-[68px] border border-gold bg-card px-3 py-2 font-mono text-2xl font-semibold text-gold" data-id="element-121">
                    {String(value).padStart(2, '0')}
                  </div>
                  <p className="mt-1 font-mono text-[8px] uppercase tracking-[0.12em] text-sage" data-id="element-122">
                    {label}
                  </p>
                </div>)}
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}